module.exports = __webpack_public_path__ + "static/media/BroadCast.1488e611.svg";